import {
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Theme,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';

import { useGetBoardsNamesQuery } from '../../../../graphql/gen/types';
import { TextSizesEnum } from '../../../../theme';
import { ButtonColor, PlexButton } from '../../../shared/primitives/PlexButton';
import { PlexTypography } from '../../../shared/primitives/PlexTypography';

interface Props {
  open: boolean;
  onClose: () => void;
  onDelete: (faqDestinationBoardTarget: string, deleteAllFaqs: boolean) => void;
  currentBoardId: string;
  plexId: string;
}

type DeleteAction = { type: 'DELETE' } | { type: 'MOVE_TO_BOARD'; boardId: string | null };

export function DeleteDialogContent(props: Props): React.ReactElement {
  const { open, onClose, onDelete, currentBoardId, plexId } = props;
  const [faqDeleteAction, setFaqDeleteAction] = useState<DeleteAction>({ type: 'MOVE_TO_BOARD', boardId: null });
  const { data: boardsData, loading: loadingBoards } = useGetBoardsNamesQuery({
    variables: { plexId },
  });
  const classes = useStyles();

  useEffect(() => {
    if (!open) {
      setFaqDeleteAction({ type: 'MOVE_TO_BOARD', boardId: null });
    }
  }, [open]);

  if (loadingBoards) {
    return <CircularProgress size={24} />;
  }
  return (
    <Dialog onClose={onClose} open={open} classes={{ paper: classes.dialogContainer }}>
      <DialogTitle>Confirmation</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <PlexTypography
            text={'Before deleting the board choose what to do with the FAQs'}
            size={TextSizesEnum.Normal}
          />
        </DialogContentText>
        <div className={classes.inputs}>
          {loadingBoards ? (
            <CircularProgress size={24} />
          ) : (
            <>
              <FormControlLabel
                className={classes.checkbox}
                control={
                  <Checkbox
                    checked={faqDeleteAction.type === 'DELETE'}
                    onChange={(): void => {
                      if (faqDeleteAction.type === 'DELETE') {
                        setFaqDeleteAction({ type: 'MOVE_TO_BOARD', boardId: null });
                      } else {
                        setFaqDeleteAction({ type: 'DELETE' });
                      }
                    }}
                  />
                }
                label="Delete all FAQs in this board"
              />
              {faqDeleteAction.type === 'MOVE_TO_BOARD' && (
                <FormControl>
                  <InputLabel id={'boardPicker'}>Move all FAQs to board</InputLabel>
                  <Select
                    labelId={'boardPicker'}
                    onChange={(event): void => {
                      setFaqDeleteAction({ type: 'MOVE_TO_BOARD', boardId: event.target.value as string });
                    }}
                    value={faqDeleteAction.boardId || ''}
                  >
                    {boardsData?.loggedIn?.plexById?.boards
                      ?.filter((pb) => pb.id !== currentBoardId)
                      .map((pb) => (
                        <MenuItem key={pb.id} value={pb.id}>
                          {pb.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              )}
            </>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <PlexButton
          color={ButtonColor.TransparentBlack}
          label={'Cancel'}
          onClick={(): void => {
            onClose();
          }}
        />
        <PlexButton
          color={ButtonColor.RedBackground}
          label={'Delete'}
          onClick={(): void => {
            switch (faqDeleteAction.type) {
              case 'MOVE_TO_BOARD': {
                if (!faqDeleteAction.boardId) {
                  alert("You have to choose a destination board for all FAQs if you don't want to delete them");
                  return;
                }
                onDelete(faqDeleteAction.boardId, false);
                break;
              }
              case 'DELETE':
                onDelete('null', true);
                break;
            }
            onClose();
          }}
        />
      </DialogActions>
    </Dialog>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  dialogContainer: { minWidth: 400, height: 260 },
  checkbox: {},
  inputs: {
    display: 'flex',
    flexDirection: 'column',
  },
}));
